module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital03-a9235d22f8af6cb692d6855544d28218.png";